module.exports = __webpack_public_path__ + "static/media/2.3e820e46.jpg";